import React, { useState, useEffect } from "react";
import { getOneData, postData } from "../../components/helpers/Data";
import { Spinner } from "../../components/helpers/Spinner";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import htmlToPdfmake from "html-to-pdfmake";
import pdfMake from "pdfmake/build/pdfmake";

const AuditTrails = () => {
  const [selectedOption, setSelectedOption] = useState("0");
  const [logData, setLogData] = useState([]);
  const [visibleState, setVisibleState] = useState({
    print: true,
    excel: true,
    username: true,
    from: true,
    to: true,
  });
  var index = 0;

  useEffect(() => {
    setLogData([]);
    document.getElementById("username").value = "";
    document.getElementById("from").value = "";
    document.getElementById("to").value = "";
    switch (selectedOption) {
      case "0":
        setVisibleState({
          ...visibleState,
          username: true,
          from: true,
          to: true,
        });
        break;
      case "1":
        setVisibleState({
          ...visibleState,
          username: false,
          from: true,
          to: true,
        });
        break;
      case "2":
        setVisibleState({
          ...visibleState,
          username: true,
          from: false,
          to: false,
        });
        break;
      case "3":
        setVisibleState({
          ...visibleState,
          username: true,
          from: true,
          to: true,
        });
        break;

      default:
        setVisibleState({
          ...visibleState,
          username: true,
          from: true,
          to: true,
        });
        break;
    }
  }, [selectedOption]);

  const fetchReport = (e) => {
    e.preventDefault();
    setLogData([]);
    const frmData = new FormData(document.getElementById("audit_trails_frm"));
    frmData.append("options", selectedOption);
    document.getElementById("spinner").style.display = "block";
    postData(frmData, "fetch_audit_trails")
      .then((data) => {
        // return console.log(data);
        setLogData(data);
        document.getElementById("spinner").style.display = "none";
      })
      .catch((error) => console.log(error));
  };

  const printPdf = (e) => {
    e.preventDefault();
    var params = "";
    switch (selectedOption) {
      case "1":
        const username = document.getElementById("username").value;
        params = `User - (${username})`;
        break;
      case "2":
        const from = document.getElementById("from").value;
        const to = document.getElementById("to").value;
        params = `Date - (${from} to ${to})`;
        break;
      case "3":
        params = "All";
        break;

      default:
        break;
    }

    let title = "AUDIT TRAIL";
    var tbl = document.getElementById("card_reprint_div").innerHTML;

    let j = `
  <div class="row">
  <br><br><br>
  <div class="row">
  <div class="col-md-4" style="font-size:25px;font-weight:bold;text-align:center;">${title}</div>
  <div class="col-md-4" style="font-weight:bold;">${params}</div>
  <br>
  <div class="col-md-4 ml-auto" style="font-weight:bold; text-align: right"></div>
  </div>
  <div>${tbl}</div>  
  </div>
  `;

    var val = htmlToPdfmake(j);
    var dd = {
      pageOrientation: "landscape",
      pageMargins: [40, 60, 40, 60],
      content: val,
      pageSize: "A4",
    };
    pdfMake.createPdf(dd).download();
  };
  return (
    <div>
      <div className=" ml-0">
        <h4 className="fs-title">AUDIT TRAIL</h4>
        <form id="audit_trails_frm" onSubmit={fetchReport}>
          <div className="row">
            <select
              type="text"
              className="form-control-sm col-md-12"
              onChange={(e) => setSelectedOption(e.target.value)}
            >
              <option selected disabled value="0">
                Select Search Option
              </option>
              <option value="1">User</option>
              <option value="2">Date</option>
              <option value="3">All</option>
            </select>
            <input
              hidden={visibleState.username}
              type="text"
              name="username"
              id="username"
              placeholder="Type Username"
              className="form-control col-7 m-1"
            />
            <label
              htmlFor="from"
              className="col-form-label col-1 m-1"
              hidden={visibleState.from}
            >
              From:
            </label>
            <input
              className="form-control col-3 m-1"
              hidden={visibleState.from}
              type="date"
              name="from"
              id="from"
            />
            <label
              htmlFor="to"
              className="col-form-label col-1 m-1"
              hidden={visibleState.to}
            >
              To:
            </label>
            <input
              className="form-control col-3 m-1"
              type="date"
              name="to"
              id="to"
              hidden={visibleState.to}
            />
            <button type="submit" className="btn btn-info btn-sm col-2 m-1">
              Run
            </button>
          </div>
        </form>
      </div>
      <section id="rejection_rate" className="project-tab">
        <div className="row">
          <div className="col-md-12">
            <div className="mt-0">
              <div className="row">
                <button
                  type="button"
                  className="btn btn-sm btn-info col-3 m-1"
                  onClick={printPdf}
                >
                  Print
                </button>

                <ReactHTMLTableToExcel
                  className="btn btn-sm btn-success col-3 m-1"
                  id="test-table-xls-button"
                  table="rejection_rate_report_table"
                  filename="Access_logs"
                  sheet="Access Logs"
                  buttonText="Export"
                />
              </div>

              <form>
                <div
                  className="row justify-content-center"
                  id="card_reprint_div"
                >
                  <table
                    className="table table-bordered table-sm"
                    id="rejection_rate_report_table"
                    style={{ maxHeight: "400px" }}
                  >
                    <thead>
                      <tr>
                        <th>Index</th>
                        <th>Username</th>
                        <th>Accessed Item</th>
                        <th>Inserted Item</th>
                        <th>Updated Item</th>
                        <th>Deleted Item</th>
                        <th>Browser Type</th>
                        <th>OS Type</th>
                        <th>Date Logged</th>
                      </tr>
                    </thead>
                    <tbody>
                      {logData.map((dt) => {
                        index++;
                        return (
                          <tr key={index}>
                            <td>{index}</td>
                            <td>{dt.user_name}</td>
                            <td>{dt.accessed}</td>
                            <td>{dt.inserted_item}</td>
                            <td>{dt.updated_item}</td>
                            <td>{dt.deleted_item}</td>
                            <td>{dt.browser_type}</td>
                            <td>{dt.os_type}</td>
                            <td>
                              {dt.log_date} {dt.log_time}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </form>
              <Spinner />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AuditTrails;
